<div appUserManual [userManualKey]="'project-selector'">
  @if (projects$ | async; as projects) {
    <p-select
      [options]="projects"
      optionLabel="name"
      optionValue="id"
      [ngModel]="(selectedProject$ | async)?.id"
      (onChange)="onSelectedProject($any($event).value, projects)"
      placeholder="Select project"
      appendTo="body"
      styleClass="project-selector-select"
      panelStyleClass="project-selector-panel"
      aria-label="Project selector"
      [filter]="projects.length > 8"
      filterBy="name"
    ></p-select>
  }
</div>
